import { api } from "@/lib/api";
import { getExternalConnectionLink } from "@/lib/external-connection-links";
import type { Activity } from "./use-account-activities";
import { useAccountPersons } from "./use-account-persons";
import { useCampaignsByIds } from "./use-campaigns";

export interface ExternalLinkTemplate {
  template: string;
  record_type: string;
  system: string;
}

export interface ExternalConnectionLinks {
  id: string;
  type: string;
  name: string;
  link_templates: ExternalLinkTemplate[];
}

export function useExternalConnectionLinks() {
  return api.useQuery<ExternalConnectionLinks[]>(
    "organization/external-connection-links/",
  );
}

interface UseActivityExternalConnectionLinkProps {
  accountId?: string;
  activity: Activity | null;
}
export function useActivityExternalConnectionLink({
  accountId,
  activity,
}: UseActivityExternalConnectionLinkProps) {
  const { data: externalConnectionLinks } = useExternalConnectionLinks();
  const { getPersonHubspotContactId } = useAccountPersons(accountId);
  const hubspotContactId = getPersonHubspotContactId(activity);

  // If the activity is a campaign, we need to get the content id for Hubspot linking
  const campaignIds =
    activity?.campaign_id && activity?.source_record_type === "campaign"
      ? [activity?.campaign_id]
      : [];
  const { data: campaigns } = useCampaignsByIds(campaignIds);
  const hubspotContentId =
    campaigns?.results[0]?.additional_properties?.content_id || "";

  const externalLink = getExternalConnectionLink(
    {
      source_record_id: activity?.source_record_id || "",
      source_record_type: activity?.source_record_type || "",
      hubspot_contact_id: hubspotContactId,
      hubspot_content_id: hubspotContentId,
    },
    externalConnectionLinks,
  );
  return externalLink;
}
